// Please keep alphabetized
export enum IconName {
  AADLogo,
  Accept,
  AccessLogo,
  Accounts,
  Add,
  AddEvent,
  AddFavorite,
  AddFavoriteFill,
  AddFriend,
  AddGroup,
  AddOnlineMeeting,
  AddPhone,
  AddTo,
  Admin,
  AdminALogo,
  AdminCLogo,
  AdminDLogo,
  AdminELogo,
  AdminLLogo,
  AdminMLogo,
  AdminOLogo,
  AdminPLogo,
  AdminSLogo,
  AdminYLogo,
  Airplane,
  AirTickets,
  AlarmClock,
  Album,
  AlbumRemove,
  AlchemyLogo,
  AlignCenter,
  AlignLeft,
  AlignRight,
  AndroidLogo,
  Annotation,
  AppForOfficeLogo,
  AppIconDefault,
  Arrivals,
  ArrowDownRight8,
  ArrowDownRightMirrored8,
  ArrowUpRight8,
  ArrowUpRightMirrored8,
  Articles,
  Ascending,
  AssetLibrary,
  Asterisk,
  ATPLogo,
  Attach,
  AustralianRules,
  AutoEnhanceOff,
  AutoEnhanceOn,
  AutoRacing,
  AwayStatus,
  AzureLogo,
  Back,
  BackToWindow,
  Badge,
  Balloons,
  BarChart4,
  BarChartHorizontal,
  Baseball,
  BidiLtr,
  BidiRtl,
  BingLogo,
  BlockContact,
  Blocked,
  Blocked2,
  BlowingSnow,
  Boards,
  Bold,
  BookingsLogo,
  Bookmarks,
  BookmarksMirrored,
  BoxLogo,
  BranchFork,
  Breadcrumb,
  Brightness,
  Broom,
  BufferTimeAfter,
  BufferTimeBefore,
  BufferTimeBoth,
  BulletedList,
  BulletedListMirrored,
  BusSolid,
  Cafe,
  Cake,
  CalculatorAddition,
  CalculatorSubtract,
  Calendar,
  CalendarAgenda,
  CalendarDay,
  CalendarMirrored,
  CalendarReply,
  CalendarWeek,
  CalendarWorkWeek,
  CaloriesAdd,
  Camera,
  Cancel,
  Car,
  CaretBottomLeftSolid8,
  CaretBottomRightSolid8,
  CaretDown8,
  CaretDownSolid8,
  CaretHollow,
  CaretHollowMirrored,
  CaretLeft8,
  CaretLeftSolid8,
  CaretRight8,
  CaretRightSolid8,
  CaretSolid,
  CaretSolidMirrored,
  CaretTopLeftSolid8,
  CaretTopRightSolid8,
  CaretUp8,
  CaretUpSolid8,
  Cat,
  CellPhone,
  Certificate,
  Chart,
  Chat,
  ChatInviteFriend,
  Checkbox,
  CheckboxComposite,
  CheckboxIndeterminate,
  CheckList,
  CheckMark,
  ChevronDown,
  ChevronDownMed,
  ChevronDownSmall,
  ChevronLeft,
  ChevronLeftMed,
  ChevronLeftSmall,
  ChevronRight,
  ChevronRightMed,
  ChevronRightSmall,
  ChevronUp,
  ChevronUpMed,
  ChevronUpSmall,
  ChromeBack,
  ChromeBackMirrored,
  ChromeClose,
  ChromeMinimize,
  CircleFill,
  CircleHalfFull,
  CirclePlus,
  CircleRing,
  ClassNotebookLogo,
  ClassroomLogo,
  Clear,
  ClearFilter,
  ClearFormatting,
  ClearNight,
  Clock,
  ClosedCaption,
  ClosePane,
  ClosePaneMirrored,
  CloudAdd,
  CloudDownload,
  CloudUpload,
  CloudWeather,
  Cloudy,
  Cocktails,
  Code,
  Coffee,
  CollabsDBLogo,
  CollapseMenu,
  CollegeFootball,
  CollegeHoops,
  Color,
  Combine,
  CompassNW,
  Completed,
  CompletedSolid,
  Contact,
  ContactCard,
  ContactInfo,
  Contrast,
  Copy,
  Cotton,
  Cricket,
  CSS,
  CustomIcon,
  CustomList,
  CustomListMirrored,
  Cycling,
  DataConnectionLibrary,
  DateTime,
  DateTime2,
  DateTimeMirrored,
  DecreaseIndentLegacy,
  Delete,
  DelveAnalytics,
  DelveAnalyticsLogo,
  DelveLogo,
  Descending,
  Design,
  DeveloperTools,
  Devices3,
  Devices4,
  Dialpad,
  Dictionary,
  DietPlanNotebook,
  DisableUpdates,
  Dislike,
  DockLeft,
  DockLeftMirrored,
  DockRight,
  DocLibrary,
  DocsLogo,
  Document,
  Documentation,
  DocumentReply,
  DocumentSearch,
  DocumentSet,
  Door,
  DoubleBookmark,
  DoubleChevronDown,
  DoubleChevronDown12,
  DoubleChevronLeft,
  DoubleChevronLeft12,
  DoubleChevronLeftMed,
  DoubleChevronLeftMedMirrored,
  DoubleChevronRight,
  DoubleChevronRight12,
  DoubleChevronUp,
  DoubleChevronUp12,
  Down,
  Download,
  DRM,
  Drop,
  DropboxLogo,
  Dropdown,
  Duststorm,
  Dynamics365Logo,
  DynamicSMBLogo,
  EatDrink,
  EdgeLogo,
  Edit,
  EditMail,
  EditMirrored,
  EditNote,
  EditPhoto,
  EditStyle,
  Embed,
  EMI,
  Emoji,
  Emoji2,
  EmojiDisappointed,
  EmojiNeutral,
  EmptyRecycleBin,
  Equalizer,
  EraseTool,
  Error,
  ErrorBadge,
  Event,
  EventInfo,
  ExcelDocument,
  ExcelLogo,
  ExchangeLogo,
  ExpandMenu,
  FabricAssetLibrary,
  FabricDataConnectionLibrary,
  FabricDocLibrary,
  FabricFolder,
  FabricFolderFill,
  FabricFolderSearch,
  FabricFormLibrary,
  FabricFormLibraryMirrored,
  FabricMovetoFolder,
  FabricNewFolder,
  FabricOpenFolderHorizontal,
  FabricPictureLibrary,
  FabricPublicFolder,
  FabricReportLibrary,
  FabricReportLibraryMirrored,
  FabricSyncFolder,
  FabricUnsyncFolder,
  FacebookLogo,
  Family,
  FangBody,
  FavoriteList,
  FavoriteStar,
  FavoriteStarFill,
  Fax,
  Ferry,
  FerrySolid,
  Filter,
  Filters,
  Financial,
  Fingerprint,
  Flag,
  FlickDown,
  FlickLeft,
  FlickRight,
  FlickUp,
  Flow,
  Fog,
  Folder,
  FolderFill,
  FolderHorizontal,
  FolderOpen,
  FolderSearch,
  Font,
  FontColor,
  FontDecrease,
  FontIncrease,
  FontSize,
  FormLibrary,
  FormLibraryMirrored,
  Forward,
  ForwardEvent,
  Freezing,
  Frigid,
  FullCircleMask,
  FullScreen,
  Generate,
  Giftbox,
  GiftCard,
  Glasses,
  Glimmer,
  GlobalNavButton,
  Globe,
  GlobeFavorite,
  Golf,
  GoogleDriveLogo,
  GotoToday,
  GripperTool,
  Group,
  GroupedAscending,
  GroupedDescending,
  GroupedList,
  HailDay,
  HailNight,
  Handwriting,
  Header1,
  Header2,
  Header3,
  Header4,
  Headset,
  Health,
  Heart,
  HeartFill,
  Help,
  HelpMirrored,
  Hide,
  Hide2,
  History,
  Home,
  HomeSolid,
  Hospital,
  Hotel,
  Important,
  InboxCheck,
  IncidentTriangle,
  IncreaseIndentLegacy,
  Info,
  Info2,
  InsertTextBox,
  InternetSharing,
  iOSAppStoreLogo,
  IssueTracking,
  IssueTrackingMirrored,
  Italic,
  JoinOnlineMeeting,
  JS,
  Label,
  LandscapeOrientation,
  LaptopSelected,
  LargeGrid,
  Library,
  Lifesaver,
  LifesaverLock,
  Light,
  Lightbulb,
  LightningBolt,
  Like,
  Link,
  List,
  ListMirrored,
  Location,
  LocationCircle,
  LocationDot,
  LocationFill,
  Lock,
  LowerBrightness,
  LyncLogo,
  Mail,
  MailAlert,
  MailCheck,
  MailFill,
  MailForward,
  MailForwardMirrored,
  MailLowImportance,
  MailPause,
  MailRepeat,
  MailReply,
  MailReplyAll,
  MailReplyAllMirrored,
  MailReplyMirrored,
  MapDirections,
  MapPin,
  Market,
  MarketDown,
  Megaphone,
  Memo,
  Merge,
  Message,
  MessageFill,
  Microphone,
  MicrosoftStaffhubLogo,
  MiniLink,
  MobileSelected,
  Money,
  More,
  MoreSports,
  Move,
  MoveToFolder,
  MSNLogo,
  MultiSelect,
  MultiSelectMirrored,
  MusicInCollection,
  MusicInCollectionFill,
  MusicNote,
  Nav2DMapView,
  NewFolder,
  News,
  None,
  NoteForward,
  NotePinned,
  NoteReply,
  NumberedList,
  NumberField,
  OfficeAssistantLogo,
  OfficeFormLogo,
  OfficeLogo,
  OfficeStoreLogo,
  OfficeVideoLogo,
  OfflineOneDriveParachute,
  OfflineOneDriveParachuteDisabled,
  OneDrive,
  OneDriveAdd,
  OneNoteEduLogo,
  OneNoteLogo,
  OpenFile,
  OpenFolderHorizontal,
  OpenInNewWindow,
  OpenPane,
  OpenPaneMirrored,
  Org,
  OutlookLogo,
  OutOfOffice,
  Package,
  Page,
  PageAdd,
  PageCheckedin,
  PageCheckedOut,
  PageLeft,
  PageRight,
  PageSolid,
  PanoIndicator,
  ParatureLogo,
  PartlyCloudyDay,
  PartlyCloudyNight,
  PartyLeader,
  Pause,
  PaymentCard,
  PC1,
  PDF,
  PencilReply,
  People,
  PeopleAdd,
  PeopleAlert,
  PeopleBlock,
  PeoplePause,
  PeopleRepeat,
  Permissions,
  Phone,
  Photo2,
  Photo2Add,
  Photo2Remove,
  PhotoCollection,
  Picture,
  PictureLibrary,
  PieDouble,
  Pill,
  Pin,
  Pinned,
  PinnedFill,
  Planner,
  Play,
  PlayerSettings,
  POI,
  PostUpdate,
  PowerApps,
  PowerApps2Logo,
  PowerAppsLogo,
  PowerBILogo,
  PowerPointDocument,
  PowerPointLogo,
  Precipitation,
  PresenceChickletVideo,
  Preview,
  PreviewLink,
  Print,
  PrintfaxPrinterFile,
  Product,
  ProFootball,
  ProHockey,
  ProjectLogo,
  ProtectedDocument,
  PublicCalendar,
  PublicContactCard,
  PublicEmail,
  PublicFolder,
  Puzzle,
  Questionnaire,
  QuestionnaireMirrored,
  QuickNote,
  RadioBtnOn,
  RadioBullet,
  Rain,
  RainShowersDay,
  RainShowersNight,
  RainSnow,
  Read,
  ReadingMode,
  ReceiptCheck,
  ReceiptForward,
  ReceiptReply,
  Recent,
  RecurringEvent,
  RecurringTask,
  RecycleBin,
  RedEye,
  Redo,
  Refresh,
  ReminderGroup,
  Remove,
  RemoveEvent,
  RemoveFilter,
  RemoveLink,
  RemoveOccurrence,
  Rename,
  ReopenPages,
  Repair,
  Reply,
  ReplyAll,
  ReplyAllAlt,
  ReplyAllMirrored,
  ReplyAlt,
  ReplyMirrored,
  ReportLibrary,
  ReportLibraryMirrored,
  ReturnToSession,
  RevToggleKey,
  Ribbon,
  RightDoubleQuote,
  Ringer,
  Room,
  Rotate,
  Rugby,
  Running,
  Sad,
  Save,
  SaveAs,
  Search,
  Section,
  Sections,
  SecurityGroup,
  Send,
  SendMirrored,
  SetAction,
  Settings,
  Share,
  ShareiOS,
  SharepointLogo,
  Shield,
  Shop,
  ShoppingCart,
  ShowResults,
  ShowResultsMirrored,
  SidePanel,
  SingleBookmark,
  SIPMove,
  SkypeCheck,
  SkypeCircleCheck,
  SkypeCircleClock,
  SkypeCircleMinus,
  SkypeClock,
  SkypeLogo,
  SkypeMessage,
  SkypeMinus,
  SliderThumb,
  Snow,
  SnowShowerDay,
  SnowShowerNight,
  Soccer,
  SocialListeningLogo,
  Sort,
  SortDown,
  SortLines,
  SortUp,
  Speakers,
  SpeedHigh,
  Split,
  Squalls,
  StackIndicator,
  Starburst,
  StatusErrorFull,
  StatusTriangle,
  StockDown,
  StockUp,
  Stopwatch,
  StoreLogo,
  StoreLogoMed,
  Strikethrough,
  Subscribe,
  Subscript,
  Suitcase,
  SunAdd,
  Sunny,
  SunQuestionMark,
  Superscript,
  SwayLogo,
  Switch,
  SwitcherStartEnd,
  Sync,
  SyncFolder,
  SyncToPC,
  System,
  Tab,
  Table,
  Tablet,
  TabletSelected,
  Tag,
  TaskManager,
  TaskManagerMirrored,
  Teamwork,
  TemporaryUser,
  Tennis,
  TextBox,
  TextField,
  ThumbnailView,
  ThumbnailViewMirrored,
  Thunderstorms,
  Ticket,
  Tiles,
  Tiles2,
  Timeline,
  Timer,
  ToggleBorder,
  ToggleFilled,
  ToggleThumb,
  Touch,
  TouchPointer,
  Train,
  TrainSolid,
  TransferCall,
  TriangleDown12,
  TriangleLeft12,
  TriangleRight12,
  TriangleSolidDown12,
  TriangleSolidLeft12,
  TriangleSolidRight12,
  TriangleSolidUp12,
  TriangleUp12,
  Trophy,
  TurnRight,
  TVMonitor,
  TVMonitorSelected,
  Underline,
  Undo,
  Unfavorite,
  UnknownCall,
  Unlock,
  Unpin,
  Unsubscribe,
  UnsyncFolder,
  Up,
  Upload,
  Video,
  VideoSolid,
  View,
  ViewAll,
  ViewAll2,
  VisioLogo,
  VoicemailForward,
  VoicemailReply,
  Volume0,
  Volume1,
  Volume2,
  Volume3,
  VolumeDisabled,
  Waffle,
  Warning,
  Website,
  Weights,
  WindDirection,
  WindowsLogo,
  WipePhone,
  WordDocument,
  WordLogo,
  Work,
  WorkFlow,
  WorldClock,
  YammerLogo,
  Zoom,
  ZoomIn,
  ZoomOut,
}